class ProductMediaScroll {
  constructor() {
    this.thumbnails = document.querySelectorAll(".product__media-thumb");
    this.mediaItems = document.querySelectorAll(".product__media-item");
    this.init();
  }

  init() {
    this.thumbnails.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const mediaId = thumb.dataset.mediaId;

        // Find the corresponding media item
        const targetMedia = Array.from(this.mediaItems).find(
          (item) => item.dataset.mediaId === mediaId
        );

        if (targetMedia) {
          // Calculate the scroll position: element's position relative to the document + window's scroll position - desired top offset
          const rect = targetMedia.getBoundingClientRect();
          const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
          const targetPosition = rect.top + scrollTop - 124;

          window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
          });
        }
      });
    });
  }
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new ProductMediaScroll();
});
